import { Suspense } from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/home/Home";
import Login from "../pages/auth/Login";

import ForgotPassword from "../pages/auth/ForgotPassword";

import ResetPassword from "../pages/auth/ResetPassword";

import ChangePassword from "../pages/auth/ChangePassword";

import OfferStatusAcceptance from "../pages/onboarding/OfferStatusAcceptance";

import ThankYou from "../pages/onboarding/ThankYou";

import ProtectedRoute from "../components/ProtectedRoute";
import PermissionGuard from "../components/PermissionGuard";

import OrgStructure from "../pages/admin/org-management/org-structure/OrgStructure";

import Overview from "../pages/admin/my-team/overview/Overview";

import PreOnboarding from "../pages/admin/my-team/pre-onboarding/PreOnboarding";

import InitiateOnboarding from "../pages/admin/my-team/pre-onboarding/InitiateOnboarding";

import EmployeeDirectory from "../pages/admin/my-team/employee-directory/EmployeeDirectory";

import AddEmployee from "../pages/admin/my-team/employee-directory/AddEmployee";
import EmployeeDetails from "../pages/admin/my-team/employee-directory/EmployeeDetails";
import PendingDocumentsReport from "../pages/admin/my-team/employee-directory/PendingDocumentsReport";
import PendingDocumentsDirectory from "../pages/admin/my-team/employee-directory/PendingDocumentsDirectory";
import ExpiredJoiningDirectory from "../pages/admin/my-team/employee-directory/ExpiredJoiningDirectory";
import RoleAndPermission from "../pages/admin/org-management/role-management/RoleAndPermission";
import EmployeeOnboardingLanding from "../components/EmployeeOnboardingLanding";

import OrgSetup from "../pages/admin/org-management/org-setup/OrgSetup";
import MyOrganization from "../pages/admin/org-management/my-org/MyOrganization";
import LoginPage from "../pages/auth/LoginPage";
import ShiftAndSchedule from "../pages/admin/shift-schedule/ShiftAndSchedule";
import AddShift from "../pages/admin/shift-schedule/AddShift";
import AddDepartment from "../pages/admin/org-management/org-structure/department/AddDepartment";
import AddDesignation from "../pages/admin/org-management/org-structure/designation/AddDesignation";
import AddLegalEntity from "../pages/admin/org-management/org-structure/legal-entities/AddLegalEntity";
import AddLocation from "../pages/admin/org-management/org-structure/location/AddLocation";
import AdminDashboard from "../pages/admin/dashboard/AdminDashboard";
import Unauthorized from "../pages/error/Unauthorized";



const AppRoutes = () => (

  <Suspense fallback={<div>Loading...</div>}>

    <Routes>
      {/* <Route path="/" element={<LandingPage />} /> */}
      <Route path="/login" element={<LoginPage />} />

      <Route path="/forgot-password" element={<ForgotPassword />} />

      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/change-password" element={<ChangePassword />} />

      <Route path="/offer-acceptance" element={<OfferStatusAcceptance />} />

      <Route path="/thank-you" element={<ThankYou />} />

      <Route path="/unauthorized" element={<Unauthorized />} />

      <Route path="/role-and-permission" element={<Navigate to="/org-management/role-and-permission" replace />} />

      <Route path="/" element={<Navigate to="/dashboard" replace />} />



      <Route path="/dashboard" element={

        <ProtectedRoute>

          <AdminDashboard />

        </ProtectedRoute>

      } />


      <Route path="/pre-onboarding/initiate" element={
        <ProtectedRoute>
          <PermissionGuard module="onboarding" action="create" fallback={<Unauthorized />}>
            <InitiateOnboarding />
          </PermissionGuard>
        </ProtectedRoute>
      } />

      <Route path="/org-management" element={
        <ProtectedRoute>
          <Navigate to="/org-management/org-structure" replace />
        </ProtectedRoute>
      } />

      <Route path="/org-management/org-structure" element={

        <ProtectedRoute>

          <OrgStructure />

        </ProtectedRoute>

      } />



      <Route path="/org-management/org-structure/:tab" element={

        <ProtectedRoute>

          <OrgStructure />

        </ProtectedRoute>

      } />






      <Route path="/org-management/org-structure/add-department" element={

        <ProtectedRoute>
          <PermissionGuard module="department" action="create" fallback={<Unauthorized />}>
            <AddDepartment />
          </PermissionGuard>
        </ProtectedRoute>

      } />



      <Route path="/org-management/org-structure/add-designation" element={

        <ProtectedRoute>
          <PermissionGuard module="designation" action="create" fallback={<Unauthorized />}>
            <AddDesignation />
          </PermissionGuard>
        </ProtectedRoute>

      } />



      <Route path="/org-management/org-structure/edit-department/:id" element={

        <ProtectedRoute>
          <PermissionGuard module="department" action="edit" fallback={<Unauthorized />}>
            <AddDepartment />
          </PermissionGuard>
        </ProtectedRoute>

      } />


      <Route path="/org-management/org-structure/add-legal-entity" element={

        <ProtectedRoute>
          <PermissionGuard module="entities" action="create" fallback={<Unauthorized />}>
            <AddLegalEntity />
          </PermissionGuard>
        </ProtectedRoute>

      } />


      <Route path="/org-management/org-structure/edit-legal-entity/:id" element={

        <ProtectedRoute>
          <PermissionGuard module="entities" action="edit" fallback={<Unauthorized />}>
            <AddLegalEntity />
          </PermissionGuard>
        </ProtectedRoute>

      } />


      <Route path="/org-management/org-structure/add-location" element={

        <ProtectedRoute>

          <AddLocation />

        </ProtectedRoute>

      } />


      <Route path="/org-management/org-structure/edit-location/:id" element={

        <ProtectedRoute>

          <AddLocation />

        </ProtectedRoute>

      } />


      <Route path="/org-management/org-structure/edit-designation/:id" element={

        <ProtectedRoute>
          <PermissionGuard module="designation" action="edit" fallback={<Unauthorized />}>
            <AddDesignation />
          </PermissionGuard>
        </ProtectedRoute>

      } />



      {/* <Route path="/org-management/org-structure/add-designation" element={<AddDesignation />} /> */}



      <Route path="/settings/company-details" element={

        <ProtectedRoute>

          <OrgSetup />

        </ProtectedRoute>

      } />

      <Route path="/settings/company-details/:tab" element={

        <ProtectedRoute>

          <OrgSetup />

        </ProtectedRoute>

      } />

      <Route path="/org-management/role-and-permission" element={

        <ProtectedRoute>

          <RoleAndPermission />

        </ProtectedRoute>

      } />

      <Route path="/org-management/org-setup" element={

        <ProtectedRoute>

          <OrgSetup />

        </ProtectedRoute>

      } />

      <Route path="/org-management/org-setup/:tab" element={

        <ProtectedRoute>

          <OrgSetup />

        </ProtectedRoute>

      } />

      <Route path="/org-management/my-org" element={

        <ProtectedRoute>

          <MyOrganization />

        </ProtectedRoute>

      } />



      <Route path="/my-team" element={
        <ProtectedRoute>
          <Navigate to="/my-team/overview" replace />
        </ProtectedRoute>
      } />

      <Route path="/my-team/overview" element={

        <ProtectedRoute>

          <Overview />

        </ProtectedRoute>

      } />



      <Route path="/my-team/employee-directory" element={
        <ProtectedRoute>
          <EmployeeDirectory />
        </ProtectedRoute>
      } />

      <Route path="/my-team/pending-documents" element={
        <ProtectedRoute>
          <PendingDocumentsDirectory />
        </ProtectedRoute>
      } />

      <Route path="/my-team/employee-directory/:id" element={
        <ProtectedRoute>
          <EmployeeDetails />
        </ProtectedRoute>
      } />

      <Route path="/my-team/employee-directory/:id/pending-documents" element={
        <ProtectedRoute>
          <PendingDocumentsReport />
        </ProtectedRoute>
      } />

      <Route path="/my-team/expired-joining" element={
        <ProtectedRoute>
          <ExpiredJoiningDirectory />
        </ProtectedRoute>
      } />



      <Route path="/my-team/add-employee" element={

        <ProtectedRoute>

          <AddEmployee />

        </ProtectedRoute>

      } />

      <Route path="/my-team/add-employee/:tab" element={

        <ProtectedRoute>

          <AddEmployee />

        </ProtectedRoute>

      } />

      <Route path="/my-team/add-employee/:id/:tab" element={

        <ProtectedRoute>

          <AddEmployee />

        </ProtectedRoute>

      } />






      <Route path="/my-team/pre-onboarding" element={

        <ProtectedRoute>

          <PreOnboarding />

        </ProtectedRoute>

      } />



      <Route path="/my-team/pre-onboarding/:tab" element={

        <ProtectedRoute>

          <PreOnboarding />

        </ProtectedRoute>

      } />



      <Route path="/my-team/onboarding" element={
        // <Suspense fallback={<div>Loading...</div>}>

        <EmployeeOnboardingLanding />

        // </Suspense>
      } />



      {/* <Route path="/attendance" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } />

      <Route path="/leaves" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } />

      <Route path="/reservations" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } />

      <Route path="/billing" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } />

      <Route path="/help" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } />

      <Route path="/settings" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } />

      <Route path="/profile" element={

        <ProtectedRoute>

          <Dashboard />

        </ProtectedRoute>

      } /> */}

      {/* <Route path="/org-management/shift-schedule" element={
        <ProtectedRoute>
          <ShiftAndSchedule />
        </ProtectedRoute>
      } />

      <Route path="/org-management/shift-schedule/:tab" element={
        <ProtectedRoute>
          <ShiftAndSchedule />
        </ProtectedRoute>
      } />

      <Route path="/org-management/shift-schedule/add-shift" element={
        <ProtectedRoute>
          <AddShift />
        </ProtectedRoute>
      } /> */}

    </Routes>

  </Suspense>

);



export default AppRoutes;

